export const SWITCH_BOARD = [
    {
        id: 1,
        name: "EPA",
    },
    {
        id: 2,
        name: "CARESOFT",
    },
    {
        id: 4,
        name: "ODS",
    },
    {
        id:6,
        name : "SUBIZ"
    }

]
export const USERS_SAVE_LOG = [
    3588,
    5271,
    4199,
    1396,
    4716,
    6827,
    5271,
    4199,
    348,
    567,
    5388,
    5390,
    53,
    260,
    348,
    541,
    2368,
    2465,
    2471,
    2947,
    3082,
    51,
    4199,
    5271,
    5952,
    5967,
    5991,
    6118,
    6827,
    7616,
    7655,
    4908,
    8301,
    8332,
    8331,
    8330,
    8329,
    8107,
    7741,
    7909,
    7085,
    7403,
    8616,
    8750,
    2265,
    8745,
    6193,
    8259,
    8576,
    7834,
    4333,
    8244,
    8538,
    8243,
    7998,
    7129,
    6449,
    993,
    8679,
    429,
    8575,
    8744,
    8197,
    8578,
    6732,
    8260,
    6795,
    5655,
    6854,
    7559,
    2387,
    8577,
    8747,
    8369,
    7067,
    8633,
    7113,
    8522,
    7912,
    7841,
    475,
    7837,
    6606,
    7997,
    8634,
    7323,
    6511,
    8749,
    8748,
    4769,
    5426,
    5938,
    7838,
    5168,
    8746,
]